import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { NOTIFICATIONS_API_URL } from '@Env/environment';
import {
  NotificationsByParamsRequest,
  NotificationsItem,
  NotificationsPage,
} from '@/core/models/notification';

@Injectable({ providedIn: 'root' })
export class NotificationsService {
  private readonly baseUrl = `${NOTIFICATIONS_API_URL}/api/v1`;

  constructor(private readonly http: HttpClient) {}

  getByParams(request: NotificationsByParamsRequest): Observable<NotificationsPage> {
    let params = new HttpParams();
    Object.entries(request).forEach(([key, value]) => {
      if (value === null || value === undefined) {
        return;
      }
      params = params.set(key, String(value));
    });

    return this.http.get<NotificationsPage>(`${this.baseUrl}/notifications/by-params`, { params });
  }

  markRead(id: number): Observable<NotificationsItem> {
    return this.http.put<NotificationsItem>(`${this.baseUrl}/notifications/read/${id}`, {});
  }
}
